import {
  AssignTagsToClientCommand,
  CreateTagCommand,
  IAssignTagsToClientCommand,
  ICreateTagCommand,
  IUpdateTagCommand,
  TagSort,
  UpdateTagCommand,
} from "@growth-machine-llc/stridist-api-client";
import { tagsClient, clientTagsClient } from "../api/ApiClients";

import ServiceBase from "./ServiceBase";

class TagsService extends ServiceBase {
  async getAllTags() {
    return tagsClient.getTags();
  }
  async createTag(variables: ICreateTagCommand) {
    const command = new CreateTagCommand(variables);
    return tagsClient.createTag(command);
  }

  async updateTag(variables: IUpdateTagCommand) {
    const command = new UpdateTagCommand(variables);
    return tagsClient.updateTag(command.id, command);
  }

  async deleteTag(id: number) {
    return tagsClient.deleteTag(id);
  }

  async assignTagsToClient(variables: IAssignTagsToClientCommand) {
    const command = new AssignTagsToClientCommand(variables);
    return clientTagsClient.assignTagsToClient(command);
  }

  async getTagsPaginated(
    page: number,
    pageSize: number,
    query?: string,
    orderBy: TagSort = TagSort.NAME_ASC,
  ) {
    return tagsClient.getTagsWithPagination(page, pageSize, query, orderBy);
  }
}

export default new TagsService();
